import api from '@/api/index.js'

const email_templates = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_EMAILS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_EMAILS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_EMAILS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadEmails({commit}) {
      commit('SET_EMAILS_ERROR', null)
      commit('SET_EMAILS_LOADING', true)
      return api.get(`emails?limit=150&offset=0`)
        .then((response) => {
          commit('SET_EMAILS', response)
        })
        .catch((error) => {
          commit('SET_EMAILS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default email_templates
